import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import Toolbar from "../../components/Toolbar";
import AxiosAPI from "../../scripts/AxiosAPI";
import {
  Badge,
  Flex,
  Image,
  Modal,
  notification,
  Tabs,
} from "antd";

import { InboxOutlined, SearchOutlined } from "@ant-design/icons";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import DisableButtonRewardItem from "../../components/DisableButtonRewardItem";
import ExportCSVButton from "../../components/ExportCSVButton";
import type { UploadProps } from "antd";
import { message, Upload } from "antd";
import axios from "axios";

import FormData from "form-data";
import { profile } from "console";
interface DataType {
  email: string,
  profileType: string,
  status: string,
  tenantName: string,
  action: any,
  createdAt: Date
}
type DataIndex = keyof DataType;
function InviteTenantsComponent() {

  const [modalOpenCreate, setModalOpenCreate] = useState(false)
  const [eventTypesData, setEventTypesData] = useState([]);

  const openNewItemModal: any = () => {

    setModalOpenCreate(true);
  };

  const sendInvite = () =>{
    AxiosAPI.publicApiRequest('post','/super/tenants/invite-tenant', 
      {
        "email": email,
        "name": "",
        "profileType": tenantType
      })
      .then(()=>{
        fetchInvites();
      });
    
  };

  const fetchInvites =()=>{
    AxiosAPI.publicApiRequest('get','/super/tenants/tenant-invites','')
    .then((res: any) => {
      let _eventTypes: any = res.data;
      setEventTypesData(_eventTypes);
    })
  }
  ;
  useEffect(() => {
    fetchInvites();
  }, []);



  const [api, contextHolder] = notification.useNotification();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const [email, setEmail] = useState("")
  const [tenantType, setTenantType] = useState("")
  const searchInput = useRef<InputRef>(null);

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",      
      ...getColumnSearchProps("email"),
    },
    {
      title: "Tenant Type",
      dataIndex: "profileType",
      key: "profileType",
      width: "15%",
      ...getColumnSearchProps("profileType"),
    },
    {
      title: "Invite Accepted",
      dataIndex: "status",
      key: "status",
      width: "15%",
      ...getColumnSearchProps("status"),
    },
    {
      title: "Date Sent",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "25%",
      ...getColumnSearchProps("createdAt"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "10%",
    },
  ];

  const operations = <Button >Refresh Data</Button>;

  const [tabItems, setTabItems] = useState<any>([]);

  useEffect(() => {
    setTabItems([
      {
        label: (
          <>
            Sent invites{" "}
            <Badge count={eventTypesData.length} showZero color="#1c84ff" />
          </>
        ),
        key: 1,
        children: <Table columns={columns} dataSource={eventTypesData} />,
      },
    ]);
  }, [eventTypesData]);

  const { Dragger } = Upload;

  const [uploadFormData, setUploadFormData] = useState<any>();

  const props: UploadProps = {
    name: "file",
    multiple: false,
    showUploadList: false,
    action: "",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        const itemFile: any = info.file.originFileObj;
        console.log(itemFile);
        let data = new FormData();
        data.append("email", email);
        data.append("tenantType", tenantType);

        setUploadFormData(data);
      }

    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <>
      {contextHolder}
      {/*begin::Toolbar*/}
      <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">
        <Toolbar title={"Invite tenant"}>
          {/*begin::Toolbar*/}
          <div
            className="d-flex justify-content-end"
            data-kt-user-table-toolbar="base"
            data-select2-id="select2-data-131-i76u"
          >
            <Flex gap={16}>
              <Button type="primary" size="large" onClick={openNewItemModal}>
                Send New
              </Button>

            </Flex>
          </div>
          {/*end::Toolbar*/}
        </Toolbar>
      </div>
      {/*end::Toolbar*/}
      {/*begin::Content*/}
      <div
        id="kt_app_content"
        className="app-content  flex-column-fluid "
        data-select2-id="select2-data-kt_app_content"
      >
        {/*begin::Content container*/}
        <div
          id="kt_app_content_container"
          className="app-container  container-xxl "
          data-select2-id="select2-data-kt_app_content_container"
        >
          {/*begin::Card*/}
          <div className="card" data-select2-id="select2-data-134-i7jk">
            {/*begin::Card body*/}
            <div className="card-body py-4">
              {/*begin::Table*/}
              <div
                id="kt_table_users_wrapper"
                className="dt-container dt-bootstrap5 dt-empty-footer pt-5"
              >
                <Tabs tabBarExtraContent={operations} items={tabItems} />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Content container*/}
      </div>
      {/*end::Content*/}

      <Modal
        title={`Send new invite`}
        centered
        open={modalOpenCreate}
        onOk={() => {
          sendInvite();
          setModalOpenCreate(false);
        }}
        onCancel={() => setModalOpenCreate(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fw-semibold fs-6 mb-2">
              Email Address
            </label>

            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fw-semibold fs-6 mb-2">
              Tenant Type
            </label>
            <select
              name="card_expiry_month"
              className="form-select form-select-solid"
              data-control="select2"
              data-hide-search="true"
              data-placeholder="Month"
              onChange={(e) => setTenantType(e.target.value)}
            >
              <option />
              <option value={"SELLER"}>Seller</option>
              <option value={"BUYER"}>Buyer</option>
            </select>

            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>

        </div>
      </Modal>


    </>
  );
}

export default InviteTenantsComponent;
